export default {
  main_text: '#3e4d82',
  highlight: '#c92a1e',
};
